const selectItems = (state) => state.settings.notifications.enduser.data.items
const selectLocale = (state) => state.settings.notifications.enduser.data.locale
const selectActiveIndex = (state) => state.settings.notifications.enduser.data.activeIndex
const selectLoader = (state) => state.settings.notifications.enduser.loader
const selectError = (state) => state.settings.notifications.enduser.error
const selectSelectedRecipients = (state) =>
  state.settings.notifications.enduser.data.selectedRecipients

export {
  selectItems,
  selectLocale,
  selectLoader,
  selectError,
  selectActiveIndex,
  selectSelectedRecipients,
}
